import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserlogService {

  constructor(private http: HttpClient) { }


  createUserLog(data:any): Observable<any> {
    return this.http.post(environment.createUserLog,data);
  }
  getAllUserLog(data:any): Observable<any> {
    return this.http.post(environment.getAllUserLog,data);
  }

  getUserLog(data:any): Observable<any> {
    return this.http.post(environment.getUserLog,data);
  }
  


  
}
